import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import './styles.scss'
import logo from '../../Assets/Images/dove0.png'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <img src={logo} alt="Dove Global Logistics" className="not-found__logo" />

      <div className="not-found__code">404</div>

      <h1 className="not-found__title">Page Not Found</h1>

      <p className="not-found__desc">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div className="not-found__actions">
        <button className="btn-primary" onClick={() => navigate('/')}>
          <FontAwesomeIcon icon={solid('house')} />
          Back to Home
        </button>

        <button className="btn-outline" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={solid('arrow-left')} />
          Go Back
        </button>
      </div>
    </div>
  )
}

export default NotFound
